module.exports = __webpack_public_path__ + "static/media/img-section-1.1e067bc2.jpg";